module.exports = __webpack_public_path__ + "img/N115-1-EN.07cc57d2.png";